import * as Yup from 'yup';

import { NEW_CUSTOMER_HOME_SECURITY } from 'core/helpers/constants';

export const connectedHomeValidationSchema = (isAdvancedConnectedHome) =>
  Yup.object()
    .shape({
      monitored: Yup.string(),
      moistureDevices: Yup.number()
        .min(0, 'Number of moisture devices must be a positive number')
        .test(
          'ch-on',
          'Number of moisture devices is required. If none, enter 0.',
          (value, context) => !context.parent.monitored || context.parent?.monitored === 'N' || value >= 0
        ),
      motionDetectingDevices: Yup.number()
        .min(0, 'Number of motion-detecting devices must be a positive number')
        .test(
          'ch-on',
          'Number of motion-detecting devices is required. If none, enter 0.',
          (value, context) =>
            !context.parent.monitored || isAdvancedConnectedHome || context.parent?.monitored === 'N' || value >= 0
        )
        .nullable(),
      smokeDetectingDevices: Yup.number()
        .min(0, 'Number of smoke-detecting devices must be a positive number')
        .test(
          'ch-on',
          'Number of smoke-detecting devices is required. If none, enter 0.',
          (value, context) => !context.parent.monitored || context.parent?.monitored === 'N' || value >= 0
        ),
      theftPreventionDevices: Yup.number()
        .min(0, 'Number of theft-prevention devices must be a positive number')
        .test(
          'ch-on',
          'Number of theft-prevention devices is required. If none, enter 0.',
          (value, context) => !context.parent.monitored || context.parent?.monitored === 'N' || value >= 0
        )
        .nullable(),
      autoWaterShutoffDevices: Yup.boolean().default(false),
      agreeToTerms: Yup.boolean()
        .test('ch-on', 'You must agree to the connected home terms', function (value, context) {
          if (
            context.parent.monitored &&
            context.parent.monitored !== 'N' &&
            this.options.context.global.homeSecurityPartnerCustomerType === NEW_CUSTOMER_HOME_SECURITY.SIGN_UP_TYPE
          ) {
            return value;
          }
          return true;
        })
        .nullable(),
      providerName: Yup.string().test(
        'ch-on',
        'Connected home provider name is required',
        (_value, context) =>
          !context.parent.monitored || context.parent?.monitored === 'N' || context.parent?.providerName?.length
      )
    })
    .nullable();
